import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Longest Common Subsequence",
  url: "longest-common-subsequence",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {String} str1
* @param {String} str2
* @return {Number}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function longestCommonSubSequences(str1, str2) {
  // your code goes here        
};
`,
};

export default info;
